import { API_URL, LEXON_API_URL } from 'src/config'

export const LOGIN_TOKEN = `${API_URL}/lexnet/login-token`
export const TOKEN = `${API_URL}/lexnet/solicitud-login-token`
export const LOGOUT_LEXNET = `${API_URL}/lexnet/logout`
export const ME = `${API_URL}/me`
export const SELECT_USER = `${API_URL}/lexnet/select-user`
export const DEFAULT_USER = `${API_URL}/lexnet/default-user`
export const ERROR_LOG = `${API_URL}/error/save`

export const MESSAGE_READ = (messageId: string): string =>
  `${API_URL}/mensajes/${messageId}/verificacion-lectura`
export const MESSAGE_READ_SIGN = (): string => `${API_URL}/mensajes/firma-acuse-recibo`
export const MAKE_SEND = (): string => `${API_URL}/lexnet/enviar-bloque`
export const MESSAGES = `${API_URL}/mensajes`
export const MESSAGE = (messageId: string): string => `${API_URL}/mensajes/${messageId}`
export const MESSAGE_DOWNLOAD = (messageId: string): string =>
  `${API_URL}/mensajes/${messageId}/descargar`
export const LEXON_NOTIFICATION_CLASSIFICATION = (id: string | number): string =>
  `${API_URL}/lexon_notification_classifications/${id}`
export const ACCEPTED_REJECTED = `${API_URL}/acuses/aceptados-rechazados`

export const COMPANIES = `${API_URL}/lexon/companies`
export const EXPEDIENTS = `${API_URL}/lexon/expedients`
export const REFRESH_LEXON_TOKEN = `${API_URL}/lexon/refresh-token`

export const MENSAJE_LEXON_CLASSIFICATIONS = `${API_URL}/mensaje-lexon-classifications`
export const MENSAJE_LEXON_CLASSIFICATION = (id: number): string =>
  `${API_URL}/mensaje-lexon-classifications/${id}`

export const AVISOS_LEXNET = `${API_URL}/avisos-lexnet`
export const AVISO_LEXNET_MARK_AS_READ = (id: string | number): string =>
  `${API_URL}/avisos-lexnet/${id}/mark-as-read`

export const COLEGIOS_LIST = `${API_URL}/colegios/list`
export const COMUNIDADES_LIST = `${API_URL}/comunidades/list`
export const MATERIAS_LIST = `${API_URL}/materias/list`
export const MUNICIPIOS_LIST = `${API_URL}/municipios/list`
export const ORGANOS_JUDICIALES_LIST = `${API_URL}/organos-judiciales/list`
export const PAIS = `${API_URL}/pais/list`
export const PARTIDOS_JUDICIALES_LIST = `${API_URL}/partidos-judiciales/list`
export const PROVINCIAS_LIST = `${API_URL}/provincias/list`
export const SEXO = `${API_URL}/sexo/list`
export const SUB_TIPO_DOCUMENTO = `${API_URL}/sub-tipo-documento/list`
export const TIPOLOGIA_PROCEDIMIENTO = `${API_URL}/tipologia-procedimiento/list`
export const TIPO_DOCUMENTO = `${API_URL}/tipo-documento/list`
export const TIPO_DOCUMENTO_IDENTIFICATIVO = `${API_URL}/tipo-documento-identificativo/list`
export const TIPO_INTERVENCION = `${API_URL}/tipo-intervencion/list`
export const TIPO_PERSONA_LIST = `${API_URL}/tipo-persona/list`
export const TIPO_PROCEDIMIENTO = `${API_URL}/tipo-procedimiento/list`
export const TIPO_PROCEDIMIENTO_PIEZA = `${API_URL}/tipo-procedimiento-pieza/list`
export const TIPO_REPRESENTACION = `${API_URL}/tipo-representacion/list`
export const TIPO_RESOLUCION = `${API_URL}/tipo-resolucion/list`
export const TIPO_VIA = `${API_URL}/tipo-via/list`
export const ENTIDAD_LIST = `${API_URL}/entidades/list`
export const ENTIDAD_LIST_BY_ORGANISMO_ORIGEN = `${API_URL}/entidades/listByOrganismoOrigen`
export const ORGANISMOS_EXTRAJUDICIALES_LIST = `${API_URL}/organismos-extrajudiciales/list`

export const LEGAL_WRITING_SEND = `${API_URL}/escrito/send`
export const LEGAL_WRITING_GET = `${API_URL}/escrito/get`
export const LEGAL_WRITING_SEND_BLOCK = `${API_URL}/escrito/enviar-bloque`
export const LEGAL_WRITING_GET_CADES_MESSAGE = `${API_URL}/escrito/obtener-mensaje-cades`

export const ESCRITOS = `${API_URL}/escritos/get`
export const ESCRITO_SAVE = `${API_URL}/escrito/save`

export const CONTACTS = `${API_URL}/lexon/contacts`
export const CONTACT = `${API_URL}/lexon/contact`

export const CONTACTS_LIST = `${LEXON_API_URL}/contacts/all/get`
